// extracted by mini-css-extract-plugin
module.exports = {"thumbnail-button":"demo-video-player_thumbnail-button__XKCIN","thumbnail-image":"demo-video-player_thumbnail-image__Md0yn","play-overlay":"demo-video-player_play-overlay__ghFsy"};